// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._j1_MibCZhv_IxMHursF {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }
  
  .hgm9XjM9za9My_MjrRwh {
    margin-right: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  
  .SroEVAj5IREMPbVHr5vV {
    font-size: 16px;
    cursor: pointer;
  }
  
  .mg4nLYQmu0qX5EA5O44e {
    opacity: 0.5;
    cursor: not-allowed;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/CustomFields/CheckboxField.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n  }\n  \n  .checkbox {\n    margin-right: 10px;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n  \n  .label {\n    font-size: 16px;\n    cursor: pointer;\n  }\n  \n  .disabledLabel {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_j1_MibCZhv_IxMHursF`,
	"checkbox": `hgm9XjM9za9My_MjrRwh`,
	"label": `SroEVAj5IREMPbVHr5vV`,
	"disabledLabel": `mg4nLYQmu0qX5EA5O44e`
};
export default ___CSS_LOADER_EXPORT___;
